import * as React from 'react';
import {ChangeParameterForm, Props} from './model';

import {useAppDispatch} from '../../../../redux';
import View from './view';
import {change, SubmissionError} from 'redux-form';
import {Forms} from '../../../../shared/models/forms';
import {ValidationItem, validationPipe} from '../../../../shared/pipes';
import {useScreenState} from '../../../../shared/hooks/useScreenState';

const getFormErrors = (formData: ChangeParameterForm, validationItems: ValidationItem[]) => {
  return validationPipe(formData, validationItems);
};

export const PossibleChangeField = ({onChange, validationItems = [], ...props}: Props) => {
  const {onDisableMasking, value} = props;
  const [changeMode, setChangeMode] = useScreenState(false);
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    if (changeMode) {
      dispatch(change(Forms.changeParameter, props.type, ''));
    }
  }, [value, changeMode]);

  const onAccept = async (type: string, formData: ChangeParameterForm) => {
    const submissionError = getFormErrors(formData, validationItems);
    if (submissionError) {
      throw new SubmissionError(submissionError);
    }
    setChangeMode(false);
    onDisableMasking(false);
    if (onChange) onChange(formData[type]);
  };

  const onDecline = () => {
    dispatch(change(Forms.changeParameter, props.type, null));
    setChangeMode(false);
    onDisableMasking(false);
  };

  const onChangeMode = () => {
    setChangeMode(true);
    onDisableMasking(true);
  };

  return (
    <View
      {...props}
      value={value || ''}
      onAccept={onAccept}
      onDecline={onDecline}
      onChangeMode={onChangeMode}
      changeMode={changeMode}
    />
  );
};
